// Libs
import { createSelector } from 'reselect'

// Selectors
import featureOperations$ from './featureOperations'

// Exports
export default createSelector(
  [featureOperations$],
  function (featureOperations) {
    try {
      return Object.values(featureOperations)[0] || null
    } catch (error) {
      return null
    }
  }
)
